import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PopupCoordinates, PopupField } from '@/routes/map/PopupField.tsx';
import { HousePlugIcon, X } from 'lucide-react';
import ViewOnGoogleMaps from '@/routes/map/ViewOnGoogleMaps.tsx';

export interface EiaSubstationsPopupProps {
	longitude: number;
	latitude: number;
	properties: Record<string, string>;
	onClose: () => void;
}

interface EiaSubstationsData {
	id: string;
	name: string;
	type: string;
	status: string;
	lines: string;
	minVoltage: string;
	maxVoltage: string;
}

export function EiaSubstationsPopup({ longitude, latitude, properties, onClose }: EiaSubstationsPopupProps) {
	const SubstationsData: EiaSubstationsData = {
		id: properties.ID || '',
		name: properties.NAME || '',
		type: properties.TYPE || '',
		status: properties.STATUS || '',
		lines: properties.LINES || '',
		minVoltage: properties.MIN_VOLT || '',
		maxVoltage: properties.MAX_VOLT || ''
	};
	return (
		<Card className="bg-white dark:bg-slate-900 border shadow-lg min-w-[260px] max-w-[350px]">
			<CardHeader className="pb-2">
				<div className="flex items-center justify-between">
					<CardTitle className="flex items-center gap-2 text-sm">
						<HousePlugIcon className="h-4 w-4" />
						EIA Substations
					</CardTitle>
					<Button aria-label="close" variant="ghost" size="icon" onClick={onClose} className="h-6 w-6">
						<X className="h-3 w-3" />
					</Button>
				</div>
			</CardHeader>
			<CardContent className="space-y-3">
				<PopupCoordinates longitude={longitude} latitude={latitude} />
				<PopupField label="ID" value={SubstationsData.id} />
				<PopupField label="Name" value={SubstationsData.name} />
				<PopupField label="Line type" value={SubstationsData.type} />
				<PopupField label="Status" value={SubstationsData.status} />
				<PopupField label="Lines" value={SubstationsData.lines} />
				<PopupField label="Min (kV)" value={SubstationsData.minVoltage} />
				<PopupField label="Max (kV)" value={SubstationsData.maxVoltage} />
				<ViewOnGoogleMaps latitude={latitude} longitude={longitude} />
			</CardContent>
		</Card>
	);
}
